import React, { ChangeEventHandler, FormEvent, useState } from 'react';

import PermissionTooltip from '@dashboard/components/PermissionTooltip';
import { alertError, alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import { useInvitePlatformUserMutation } from '@dashboard/generated/wp/authentication';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { Button, Stack, TextField } from '@mui/material';

import { usePermission } from '../hooks';

export default function Component(): JsxNode {
  const permission = usePermission('invitePlatformUser');
  const [emailAddress, setEmailAddress] = useState('');
  const platformId = useCurrentPlatformId();
  const [invitePlatformUser, { loading }] = useInvitePlatformUserMutation();

  async function onSubmit(ev: FormEvent<HTMLFormElement>) {
    ev.preventDefault();
    try {
      const { data } = await invitePlatformUser({
        refetchQueries: ['PlatformUsers'],
        variables: { platformId, emailAddress },
      });

      setEmailAddress('');
      if (data?.invitePlatformUser.displayName) {
        alertSuccess(`Invite sent to ${data.invitePlatformUser.displayName}`);
      }
    } catch (_e) {
      alertError('There was an error creating the invite');
    }
  }

  const onEmailAddressChange: ChangeEventHandler<HTMLInputElement> = (ev) => {
    setEmailAddress(ev.target.value);
  };

  return (
    <Stack component="form" onSubmit={onSubmit} spacing={1} direction="row" alignItems="center">
      <TextField
        variant="outlined"
        size="small"
        type="email"
        disabled={!permission}
        placeholder="name@company.com"
        onChange={onEmailAddressChange}
        value={emailAddress}
        inputProps={{ sx: { height: 16 } }}
      />

      <PermissionTooltip span name="invitePlatformUser">
        <Button disabled={loading || !permission} variant="outlined" color="primary" type="submit">
          Send invite
        </Button>
      </PermissionTooltip>
    </Stack>
  );
}
